import styled from 'styled-components'

const StockContainer = styled.div`
  margin-bottom: 0.5rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

export default StockContainer
